export default {
  title: 'Your cart',
  purchaseLimit: 'Purchase limit:',
  emptyTitle: 'Your cart is empty',
  emptyText: 'Browse the catalog and add some game keys to get started.',
  browseCatalog: 'Browse catalog',
  removeItem: 'Remove item',
  continueShopping: 'Continue shopping',
  orderSummary: 'Order summary',
  items: 'Items ({n})',
  fees: 'Fees',
  total: 'Total',
  proceedToCheckout: 'Proceed to checkout',
  limitReached: 'order limit reached',
};
